import { network } from "../network/network.js";
export async function searchProducts(query) {
    let _query = { ...query };
    if (Array.isArray(query.attributes)) {
        for (const attribute of query.attributes) {
            _query[`attribute.${attribute.key}`] = attribute.values.join(",");
            delete _query.attributes;
        }
    }
    if (Array.isArray(query.tags)) {
        _query.tags = query.tags.join(",");
    }
    if (Array.isArray(query.categories)) {
        _query.categories = query.categories.join(",");
    }
    if (Array.isArray(query.brands)) {
        _query.brands = query.brands.join(",");
    }
    if (query.priceRange) {
        _query.priceRange = `${query.priceRange.min}-${query.priceRange.max}`;
    }
    return await network("/products", { query: _query });
}
